"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModel = exports.getModel = exports.getModels = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const modelsEndpoint = `${zenithConfigApi}${constants_1.routes.MODELS}`;
const getModels = (tenantId) => () => {
    const url = (tenantId && tenantId !== '')
        ? `${modelsEndpoint}?tenantId=${tenantId}`
        : modelsEndpoint;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getModels = getModels;
const getModel = (modelId) => () => {
    const url = (modelId && modelId !== '')
        ? `${modelsEndpoint}/${modelId}`
        : modelsEndpoint;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getModel = getModel;
const createModel = (newModel) => (zenithApiPrivate_1.default.post(modelsEndpoint, newModel)
    .then((res) => res.data));
exports.createModel = createModel;
